<div class="checkout-address-container">
  <div class="content">
    <div class="address invoice-address-container">
      <div class="headline">
        {{ 'checkout.steps.address.invoiceAddress.headline' | translate }}
      </div>
      <ng-container *ngIf="isUser$ | async; else guest">
        <div *ngFor="let address of addresses$ | async" class="address">
          <div
            (click)="selectInvoiceAddress(address.id)"
            [class.active]="address.id === (invoiceAddress$ | async)?.id && !newInvoiceAddress"
            class="existing address-container {{ (addressEditInvoice$ | async) === address.id ? 'noPadding' : '' }} {{ !address.billingAddress ? 'hide' : '' }}">
            <kion-radio
              (selected)="selectInvoiceAddress(address.id)"
              [selected]="address.id === (invoiceAddress$ | async)?.id && !newInvoiceAddress"
              [title]=""
            ></kion-radio>
            <div *ngIf="(addressEditInvoice$ | async) !== address.id; else editMode">
              <p>{{ address.title }} {{ address.firstName }} {{ address.lastName }}</p>
              <p>{{ address.email }}</p>
              <p><span>{{ address.companyName }}</span><span>{{ address.vatId }}</span></p>
              <p>{{ address.customerId }}</p>
              <p>
                <span>{{ address.line1 }}</span>
                <span>{{ address.line2 }}</span>
                <span>{{ address.postalCode }}</span>
                <span>{{ address.town }}</span>
                <span>{{ address.country?.name }}</span>
              </p>
              <p>{{ address.phone }}</p>
              <p>{{ address.cellphone }}</p>
              <kion-label-button
                (click)="setEditMode(address.id, true)"
                [title]="'checkout.steps.summary.button.edit' | translate"
              ></kion-label-button>
            </div>
            <ng-template #editMode>
              <div class="address-edit">
                <div *ngIf="titles$ | async as titles">
                  <kion-address-form
                    (changed)="updateAddress($event)"
                    [address]="address"
                    [customerNumberVisible]="true"
                    [emailConfirmationVisible]="true"
                    [isoCode]="isoCode"
                    [mobileVisible]="true"
                    [titleOptions]="titles"
                  ></kion-address-form>
                </div>
                <div>
                  <kion-label-button
                    (click)="removeEditMode(true)"
                    [title]="'checkout.steps.address.button.closeEdit' | translate"
                  ></kion-label-button>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
        <div (click)="markAsNewInvoiceAddress()" [class.active]="newInvoiceAddress" class="new address-container">
          <kion-radio
            (selected)="markAsNewInvoiceAddress()"
            [selected]="newInvoiceAddress"
            [title]="'checkout.steps.address.invoiceAddress.labels.new' | translate"
          ></kion-radio>
          <div *ngIf="titles$ | async as titles" [hidden]="!newInvoiceAddress" class="form">
            <kion-address-form
              (changed)="upsertInvoiceAddress($event)"
              [address]="(isUser$ | async) ? null : invoiceAddress$ | async"
              [customerNumberVisible]="true"
              [emailConfirmationVisible]="true"
              [isoCode]="isoCode"
              [mobileVisible]="true"
              [titleOptions]="titles"
            ></kion-address-form>
          </div>
        </div>
      </ng-container>
      <ng-template #guest>
        <ng-container *ngIf="invoiceAddress$ | async as address; else noAddress">
          <div (click)="markAsNewInvoiceAddress()" [class.active]="newInvoiceAddress" class="new address-container">
            <kion-radio
              (selected)="markAsNewInvoiceAddress()"
              [selected]="newInvoiceAddress"
              [title]="'checkout.steps.address.invoiceAddress.labels.new' | translate"
            ></kion-radio>
            <div *ngIf="titles$ | async as titles" [hidden]="!newInvoiceAddress" class="form">
              <kion-address-form
                (changed)="upsertInvoiceAddress($event)"
                [address]="address"
                [customerNumberVisible]="true"
                [emailConfirmationVisible]="true"
                [isoCode]="isoCode"
                [mobileVisible]="true"
                [titleOptions]="titles"
              ></kion-address-form>
            </div>
          </div>
        </ng-container>
        <ng-template #noAddress>
          <div (click)="markAsNewInvoiceAddress()" [class.active]="newInvoiceAddress" class="new address-container">
            <kion-radio
              (selected)="markAsNewInvoiceAddress()"
              [selected]="newInvoiceAddress"
              [title]="'checkout.steps.address.invoiceAddress.labels.new' | translate"
            ></kion-radio>
            <div *ngIf="titles$ | async as titles" [hidden]="!newInvoiceAddress" class="form">
              <kion-address-form
                (changed)="upsertInvoiceAddress($event)"
                [customerNumberVisible]="true"
                [emailConfirmationVisible]="true"
                [isoCode]="isoCode"
                [mobileVisible]="true"
                [titleOptions]="titles"
              ></kion-address-form>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </div>
    <div class="address delivery-address-container">
      <div class="headline">
        {{ 'checkout.steps.address.deliveryAddress.headline' | translate }}
      </div>
      <ng-container *ngIf="isUser$ | async else guestDelivery">
        <div (click)="selectDeliveryAddress(address.id)" *ngFor="let address of addresses$ | async"
             [hidden]="address.id === (deliveryAddress$ | async)?.id && deliveryAddressSameAsInvoice || address.id === (invoiceAddress$ | async)?.id "
             class="address">
          <div
            [class.active]="address.id === (invoiceAddress$ | async)?.id"
            [class.active]="address.id === (deliveryAddress$ | async)?.id && !newDeliveryAddress"
            class="existing address-container {{ (addressEditDelivery$ | async) === address.id ? 'noPadding' : '' }}  {{ !address.shippingAddress ? 'hide' : '' }} ">
            <kion-radio
              (selected)="selectDeliveryAddress(address.id)"
              [selected]="address.id === (basket$ | async)?.deliveryAddress?.id && !deliveryAddressSameAsInvoice && !newDeliveryAddress"
              [title]=""
            ></kion-radio>
            <div *ngIf="(addressEditDelivery$ | async) !== address.id; else editMode">
              <p>{{ address.title }} {{ address.firstName }} {{ address.lastName }}</p>
              <p>{{ address.email }}</p>
              <p><span>{{ address.companyName }}</span><span>{{ address.vatId }}</span></p>
              <p>{{ address.customerId }}</p>
              <p>
                <span>{{ address.line1 }}</span>
                <span>{{ address.line2 }}</span>
                <span>{{ address.postalCode }}</span>
                <span>{{ address.town }}</span>
                <span>{{ address.country?.name }}</span>
              </p>
              <p>{{ address.phone }}</p>
              <p>{{ address.cellphone }}</p>
              <kion-label-button
                (click)="setEditMode(address.id, false)"
                [title]="'checkout.steps.summary.button.edit' | translate"
              ></kion-label-button>
            </div>
            <ng-template #editMode>
              <div class="address-edit">
                <div *ngIf="titles$ | async as titles">
                  <kion-address-form
                    (changed)="updateAddress($event)"
                    [address]="address"
                    [customerNumberVisible]="true"
                    [emailConfirmationVisible]="true"
                    [isoCode]="isoCode"
                    [mobileVisible]="true"
                    [titleOptions]="titles"
                  ></kion-address-form>
                </div>
                <div>
                  <kion-label-button
                    (click)="removeEditMode(false)"
                    [title]="'checkout.steps.address.button.closeEdit' | translate"
                  ></kion-label-button>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
        <div (click)="markAsSameAsInvoiceAddress()"
             [class.active]="deliveryAddressSameAsInvoice || (isSameAsInvoice$ | async) && !newDeliveryAddress"
             class="same address-container">
          <kion-radio
            (selected)="markAsSameAsInvoiceAddress()"
            [selected]="deliveryAddressSameAsInvoice || (isSameAsInvoice$ | async) && !newDeliveryAddress"
            [title]="'checkout.labels.likeInvoice' | translate"
          ></kion-radio>
        </div>
        <div (click)="createNewDeliveryAddress()" [class.active]="newDeliveryAddress" class="new address-container">
          <kion-radio
            (selected)="createNewDeliveryAddress()"
            [selected]="newDeliveryAddress"
            [title]="'checkout.labels.otherDelivery' | translate"
          ></kion-radio>
          <ng-container *ngIf="newDeliveryAddress">
            <div *ngIf="titles$ | async as titles" class="form">
              <kion-address-form
                (changed)="upsertDeliveryAddress($event)"
                [isoCode]="isoCode"
                [titleOptions]="titles"
              ></kion-address-form>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #guestDelivery>
        <div (click)="markAsSameAsInvoiceAddress()"
             [class.active]="(isSameAsInvoice$ | async) || !newDeliveryAddress && !(deliveryAddress$ | async)"
             class="same address-container">
          <kion-radio
            (selected)="markAsSameAsInvoiceAddress()"
            [selected]="(isSameAsInvoice$ | async) && deliveryAddressSameAsInvoice || !newDeliveryAddress && !(deliveryAddress$ | async)"
            [title]="'checkout.labels.likeInvoice' | translate"
          ></kion-radio>
        </div>
        <div (click)="createNewDeliveryAddress()"
             [class.active]="newDeliveryAddress || !(isSameAsInvoice$ | async) && (deliveryAddress$ | async)"
             class="new address-container">
          <kion-radio
            (selected)="createNewDeliveryAddress()"
            [selected]="!(isSameAsInvoice$ | async) && !!(deliveryAddress$ | async) || newDeliveryAddress"
            [title]="'checkout.labels.otherDelivery' | translate"
          ></kion-radio>
          <ng-container *ngIf="newDeliveryAddress || !(isSameAsInvoice$ | async) && (deliveryAddress$ | async)">
            <div *ngIf="titles$ | async as titles" class="form">
              <kion-address-form
                (changed)="upsertDeliveryAddress($event)"
                [address]="(isSameAsInvoice$ | async) ? null : deliveryAddress$ | async"
                [isoCode]="isoCode"
                [titleOptions]="titles"
              ></kion-address-form>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<div class="navigator">
  <div class="back">
    <kion-label-button [link]="backLink" [title]="'checkout.navigator.back' | translate">
      <svg height="20" img-link viewBox="0 0 16 16" width="20" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.286 4.571L2.522 4.571 6.118 0.975 5.31 0.167 0.335 5.143 5.31 10.118 6.118 9.31 2.522 5.714 14.286 5.714z"
          fill="#9B9B9E"
          fill-rule="evenodd"
          transform="translate(.571 2.857)"></path>
      </svg>
    </kion-label-button>
  </div>
  <div class="forward">
    <kion-button (clicked)="nextClicked()" [disabled]="!(canProceed$ | async) || (isUpdating$ | async)" [isLink]="false"
                 [title]="'checkout.navigator.forward' | translate" mode="primary"></kion-button>
  </div>
</div>
<div class="spacer"></div>
